import React from "react";
import {BackToTop, Page, PageSection, PageSectionVariants, SkipToContent, TextContent} from "@patternfly/react-core";
import {DiazarPageHeader} from "../Components/PageHeader/DiazarPageHeader";
import {DiazarAlerts} from "../Components/DiazarAlerts";

interface ViewProps{
    title:string;
    children?: React.ReactNode;
    description?:React.ReactNode;
}
const pageId = 'main-content-page-layout-tertiary-nav';

export const PageLayout: React.FunctionComponent<ViewProps> = (props) => {
    const PageSkipToContent = <SkipToContent href={`#${pageId}`}>Skip to content</SkipToContent>;
    const [isBackToTopVisible, setIsBackToTopVisible] = React.useState<boolean>(false);

    const onScroll = React.useCallback( (e:any) => {
        setIsBackToTopVisible((e.target as HTMLDivElement).scrollTop > 100 )
    }, [] )
    return (
        <React.Fragment>
            <Page
                header={<DiazarPageHeader />}
                isManagedSidebar
                isTertiaryNavWidthLimited
                skipToContent={PageSkipToContent}
                mainContainerId={pageId}
                additionalGroupedContent={
                    <PageSection variant={PageSectionVariants.light}>
                        <TextContent>
                            <h1>{ props.title }</h1>
                            { props.description }
                        </TextContent>
                    </PageSection>
                }
                groupProps={{
                    sticky: 'top'
                }}
            >
                <DiazarAlerts />
                <PageSection hasOverflowScroll
                             name="scrolling-section"
                             tabIndex={0}
                             onScroll={ onScroll }
                >
                    <div style={{ padding: 0, minHeight:'500px' }}>
                        { props.children }
                    </div>
                </PageSection>
                <BackToTop title="Volver arriba" scrollableSelector='[name="scrolling-section"]' isAlwaysVisible={isBackToTopVisible}/>;
            </Page>
        </React.Fragment>
    )
}